export const PORTFOLIO_VIEWS = {
    TABLE_VIEW: 0,
    GRAPH_VIEW: 1,
    FUNDS_VIEW: 2,
  };